import {UntypedFormControl, ValidationErrors} from '@angular/forms';

export const notOnlyWhitespaceValidator = (
  control: UntypedFormControl,
): ValidationErrors | null => {
  if (!control.value) {
    return null;
  }
  const isWhitespace = control.value.trim().length === 0;
  const isValid = !isWhitespace;

  return isValid ? null : {onlyWhitespace: true};
};
